export const PLAYLIST_CONFIG = {
  MAX_ITEMS: 10,
  MIN_ITEMS_FOR_SHOW_MORE: 4,
  ITEMS_PER_LOAD: 4,
} as const;

// Add these constants at the top of the file
export const PLAYLIST_STYLES = {
  IMAGE_WIDTH: 180,
  IMAGE_HEIGHT: 90,
  MAX_HEIGHT_DESKTOP: 450,
  CONTAINER_MAX_WIDTH: 1060,
  SPACING: {
    PADDING: 20,
    MARGIN: 15,
    GAP: 4,
  },
} as const;
